var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { ValidationResult, } from "@inter-ikea-core/core";
/**
 * The result of a ZoneVsZoneRule validation containing information about which function zones collided and which
 * entities they belong to.
 */
var ZoneVsZoneValidationResult = /** @class */ (function (_super) {
    __extends(ZoneVsZoneValidationResult, _super);
    function ZoneVsZoneValidationResult(resultType, failedRule, entityWithZone1, intersectingZone1, entityWithZone2, intersectingZone2) {
        var _this = _super.call(this, resultType, null, failedRule) || this;
        _this.entityWithZone1 = entityWithZone1;
        _this.intersectingZone1 = intersectingZone1;
        _this.entityWithZone2 = entityWithZone2;
        _this.intersectingZone2 = intersectingZone2;
        return _this;
    }
    Object.defineProperty(ZoneVsZoneValidationResult.prototype, "id", {
        get: function () {
            return "ZoneVsZoneValidationResult";
        },
        enumerable: false,
        configurable: true
    });
    return ZoneVsZoneValidationResult;
}(ValidationResult));
export { ZoneVsZoneValidationResult };
//# sourceMappingURL=ZoneVsZoneValidationResult.js.map